<template>
  <div class="header-area fixed-top">

    <header class="container-fluid text-center">
      <nav class="navbar navbar-expand-sm flex">
        <div class="container-fluid">
          <div class="navbar-brand flex">
            <div class="thumb-circle thumb-service">
            </div>
            <a href="#" class="teams-name"
              @click.prevent="transitionScreen('MonitoringTargetsList')"
            >{{ currentServiceAccount?.serviceAccountName }}</a>
          </div>

          <div id="Navber" class="collapse navbar-collapse">
            <div class="navbar-nav me-auto mb-2 mb-lg-0">
              <router-link
                class="nav-item nav-link"
                :class="{
                  active: isIncludedInRoute(item),
                }"
                :to="item.to"
                :key="item.label"
                v-for="item in nav"
              >
                {{ item.label }}
              </router-link>
            </div>
          </div>

          <ul class="list-unstyled flex ps-auto">
            <li class="nav-item dropdown user-menu">
              <a
                id="nav-dropdown"
                class="nav-link dropdown-toggle flex"
                href="#"
                data-bs-toggle="dropdown"
              >
                <div class="thumb-circle thumb-user">
                </div>
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" @click="logout">ログアウト</a>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <button
                type="button"
                class="navbar-toggler"
                data-bs-toggle="offcanvas"
                data-bs-target="#sub-menu"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
            </li>
          </ul>
        </div>
      </nav>
    </header>

    <!-- サブメニュー #sub-menu -->
    <div
      class="offcanvas offcanvas-end"
      id="sub-menu" tabindex="-1"
      data-bs-scroll="true"
      data-bs-backdrop="false"
      aria-labelledby="sub-menu-label"
    >
      <button
        type="button"
        class="btn-close"
        aria-label="閉じる"
        data-bs-dismiss="offcanvas"
        ref="closeMenuBnt"
        ></button>

      <dl class="list-unstyled">
        <dt class="sub-txt gray">サービスアカウントメニュー</dt>
        <dd>
          <a class="btn" href="#"
            @click.prevent="transitionScreen('MonitoringTargetsList')">監視対象一覧</a>
        </dd>
        <dd>
          <a class="btn" href="#"
            @click.prevent="transitionScreen('ServiceAccountIndex')">サービスアカウント基本設定</a>
        </dd>
        <dd>
          <a class="btn" href="#"
            @click.prevent="transitionScreen('NotificationRecipientsList')">通知アドレス一覧</a>
        </dd>
        <dd>
          <a class="btn" href="#"
            @click.prevent="transitionScreen('MonitoringDeviceList')">登録デバイス一覧</a>
        </dd>
        <dd>
          <a class="btn" href="#"
            @click.prevent="transitionScreen('BillingsList')">請求書・領収書</a>
        </dd>
      </dl>
      <dl class="list-unstyled">
        <dt class="sub-txt gray">ユーザーメニュー</dt>
        <dd>
          <a class="btn" href="#" @click="logout">ログアウト</a>
        </dd>
      </dl>
    </div><!-- end #list-notice -->

    <div
      class="status-bar flex"
      :class="{
        error: navbarNotification?.isError,
        'd-none': !navbarNotification,
        'fade-down': navbarNotification,
      }"
    >
      <span>{{ navbarNotification?.message }}</span>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { signOut } from "utils/auth";

export default {
  name: "Header",
  data() {
    return {
      nav: [
        {
          to: "/monitoring-targets",
          label: "監視対象",
        },
        {
          to: "/service-account",
          label: "設定",
          subroutes: ["monitoring-devices", "notification-recipients"],
        },
      ],
    };
  },
  computed: {
    ...mapGetters("profile", [
      "userAccount",
    ]),
    ...mapGetters("service-account", [
      "currentServiceAccount",
    ]),
    ...mapGetters("asig-project", [
      "asigProjectList",
      "currentAsigProject",
    ]),
    ...mapGetters({
      // profile
      userAccount: "profile/userAccount",
      // service-account
      currentServiceAccount: "service-account/currentServiceAccount",
      // asig-project
      asigProjectList: "asig-project/asigProjectList",
      currentAsigProject: "asig-project/currentAsigProject",
      // navbar
      navbarNotification: "notification/navbarNotification",
      navbarErrorNotifications: "notification/navbarErrorNotifications",
    }),
  },
  async created() {
  },
  methods: {
    ...mapActions("notification", [
      "setNotification",
    ]),
    async logout() {
      await signOut();
      this.$router.push({ name: "SignInForm" });
    },
    isIncludedInRoute(navItem) {
      const pathHasLink = this.$route.path.includes(navItem.to);
      let inRoute = false;

      if (!navItem.hasOwnProperty("subroutes") && pathHasLink) {
        return true;
      }

      if (navItem.hasOwnProperty("subroutes")) {
        const { subroutes } = navItem;
        inRoute = subroutes.find((route) => this.$route.path.includes(route));
      }

      return pathHasLink || inRoute;
    },
    transitionScreen(routeName) {
      this.$router.push({ name: routeName });
      this.$refs.closeMenuBnt.click();
    },
  },
};
</script>
